var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Order Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99977 10.2265V8.93315C9.99977 5.93315 12.4131 2.98649 15.4131 2.70649C16.2467 2.62459 17.0881 2.71812 17.8834 2.98107C18.6786 3.24401 19.41 3.67055 20.0304 4.23321C20.6509 4.79588 21.1466 5.48221 21.4858 6.24805C21.825 7.01388 22.0001 7.84224 21.9998 8.67982V10.5198M5.07977 22.0798L5.38644 24.5732C5.67977 27.1865 6.63977 29.3332 11.9998 29.3332H19.9998C25.3598 29.3332 26.3198 27.1865 26.5998 24.5732L27.5998 16.5732C27.9598 13.3198 27.0264 10.6665 21.3331 10.6665H10.6664C4.9731 10.6665 4.03977 13.3198 4.39977 16.5732",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.6595 16H20.6715M11.3262 16H11.3368",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.2e78e4a633c9e7339b636bf09bf78bdb.svg";
export { ForwardRef as ReactComponent };